module.exports = __webpack_public_path__ + "static/img/h1-3.6b7417a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/h1-3.png
// module id = TyPN
// module chunks = 1